import React from 'react';

const RouteLoader: React.FC = () => (
  <div
    className="min-h-screen flex items-center justify-center bg-background"
    role="status"
    aria-live="polite"
    aria-label="Se încarcă pagina"
  >
    <div className="h-10 w-10 rounded-full border-2 border-muted border-t-primary animate-spin" />
    <span className="sr-only">Se încarcă...</span>
  </div>
);

export default RouteLoader;
